<template>
  <div class="role-manage">
    <!-- 操作区域 -->
    <el-card class="operation-card" shadow="never">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
        添加角色
      </el-button>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="role" label="Role" width="120" align="center" />
        <el-table-column prop="name" label="角色名称" width="220" align="center" />
        <el-table-column prop="description" label="描述" min-width="400" align="center" />
        <el-table-column label="操作" min-width="520" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleView(scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="info" @click="handleViewMenu(scope.row)">
              查看可用菜单
            </el-button>
            <el-button
              size="mini"
              type="warning"
              :disabled="scope.row.role === 1073741824"
              @click="handleMenuDistribution(scope.row)"
            >
              菜单分配
            </el-button>
            <el-button size="mini" type="success" @click="handleClaimDistribution(scope.row)">
              产品理赔分配
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      @close="handleDialogClose"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="roleForm"
        label-width="100px"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入角色名称"
            maxlength="20"
            :disabled="isView"
          />
        </el-form-item>
        <el-form-item label="权限值" prop="role">
          <el-input-number
            v-model="formData.role"
            placeholder="请输入权限值"
            :disabled="isEdit || isView"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            v-model="formData.description"
            placeholder="请输入描述"
            maxlength="200"
            :disabled="isView"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ isView ? '关闭' : '取消' }}</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading" v-if="!isView">
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 权限配置对话框 -->
    <el-dialog
      title="菜单分配"
      :visible.sync="permissionDialogVisible"
      width="960px"
      @close="handlePermissionDialogClose"
    >
      <div style="margin-bottom: 10px;">
        <el-button size="small" @click="expandAll">展开</el-button>
        <el-button size="small" @click="collapseAll">折叠</el-button>
      </div>
      <el-tree
        ref="permissionTree"
        :data="permissionTreeData"
        v-loading="permissionLoading"
        node-key="key"
        show-checkbox
        default-expand-all
        :props="{ children: 'children', label: 'label' }"
        class="menu-permission-tree"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handlePermissionSubmit" :loading="permissionSubmitLoading">
          保存
        </el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import request from '@/lib/request'
import { getRoleMenus, saveRoleMenus } from '@/api/permission'
import { asyncRoutes } from '@/router/routerMap'
import { buildMenuTree, flattenLeafMenuKeys } from '@/utils/menuPermission'

export default {
  name: 'RoleManage',
  data() {
    return {
      // 表格数据
      tableData: [],
      tableLoading: false,
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      // 对话框
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      isView: false,
      // 表单数据
      formData: {
        name: '',
        role: null,
        description: ''
      },
      // 表单验证规则
      formRules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { max: 20, message: '长度不能超过20个字符', trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请输入权限值', trigger: 'blur' },
          { type: 'number', message: '权限值必须为数字', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      // 权限配置
      permissionDialogVisible: false,
      permissionTreeData: [],
      permissionLoading: false,
      permissionSubmitLoading: false,
      currentRole: null,
      selectedPermissions: []
    }
  },
  mounted() {
    this.loadTableData()
  },
  methods: {
    // 加载表格数据
    async loadTableData() {
      this.tableLoading = true
      try {
        const response = await request.request({
          url: '/v1/admin/cmn/role/list',
          method: 'get',
          params: {
            page: this.pagination.currentPage,
            rows: this.pagination.pageSize
          }
        })
        
        if (response.err_code === 0) {
          this.tableData = response.rows || []
          this.pagination.total = response.total || 0
        } else {
          this.$message.error(response.err_msg || '获取角色列表失败')
        }
      } catch (error) {
        console.error('获取角色列表失败:', error)
        this.$message.error('获取角色列表失败')
      } finally {
        this.tableLoading = false
      }
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '添加角色'
      this.isEdit = false
      this.isView = false
      this.formData = {
        name: '',
        role: null,
        description: ''
      }
      this.dialogVisible = true
    },

    // 查看
    async handleView(row) {
      this.dialogTitle = '查看角色信息'
      this.isEdit = false
      this.isView = true
      
      try {
        const response = await request.request({
          url: '/v1/admin/cmn/role/info',
          method: 'get',
          params: { id: row.role }
        })
        
        if (response.err_code === 0) {
          this.formData = {
            name: response.data.name,
            role: response.data.role,
            description: response.data.description
          }
          this.dialogVisible = true
        } else {
          this.$message.error(response.err_msg || '获取角色信息失败')
        }
      } catch (error) {
        console.error('获取角色信息失败:', error)
        this.$message.error('获取角色信息失败')
      }
    },

    // 编辑
    async handleEdit(row) {
      this.dialogTitle = '编辑角色信息'
      this.isEdit = true
      this.isView = false
      
      try {
        const response = await request.request({
          url: '/v1/admin/cmn/role/info',
          method: 'get',
          params: { id: row.role }
        })
        
        if (response.err_code === 0) {
          this.formData = {
            name: response.data.name,
            role: response.data.role,
            description: response.data.description
          }
          this.dialogVisible = true
        } else {
          this.$message.error(response.err_msg || '获取角色信息失败')
        }
      } catch (error) {
        console.error('获取角色信息失败:', error)
        this.$message.error('获取角色信息失败')
      }
    },

    // 查看可用菜单
    handleViewMenu(row) {
      this.$router.push({
        name: 'menuView',
        query: {
          roleId: row.role,
          roleName: row.name
        }
      });
    },

    // 菜单分配
    handleMenuDistribution(row) {
      this.currentRole = row
      this.permissionDialogVisible = true
      this.loadAllPermissions()
      this.loadRolePermissions(row.role)
    },

    // 产品理赔分配
    handleClaimDistribution(row) {
      // 跳转到产品理赔分配页面
      this.$router.push({
        name: 'claimDistribution',
        query: { id: row.role }
      })
    },

    // 删除
    handleDelete(row) {
      this.$confirm('您确定要删除选中的角色吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await request.request({
            url: '/v1/admin/cmn/role/delete',
            method: 'get',
            params: { id: row.role }
          })
          
          if (response.err_code === 0) {
            this.$message.success('删除数据成功.当前删除数目1条')
            this.loadTableData()
          } else {
            this.$message.error('删除失败')
          }
        } catch (error) {
          console.error('删除角色失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        // 取消删除
      })
    },

    // 加载前端路由中的全部可见菜单
    loadAllPermissions() {
      this.permissionLoading = true
      this.permissionTreeData = buildMenuTree(asyncRoutes)
      this.permissionLoading = false
    },

    // 加载角色权限
    async loadRolePermissions(roleId) {
      try {
        const response = await getRoleMenus({ role_id: roleId })
        
        if (response.err_code === 0) {
          const data = response.data || {}
          const selectedKeys = data.configured
            ? data.menu_keys || []
            : flattenLeafMenuKeys(this.permissionTreeData)
          this.selectedPermissions = selectedKeys
          this.$nextTick(() => {
            this.$refs.permissionTree.setCheckedKeys(selectedKeys)
          })
        } else {
          this.$message.error(response.err_msg || '获取角色权限失败')
        }
      } catch (error) {
        console.error('获取角色权限失败:', error)
        this.$message.error('获取角色权限失败')
      }
    },

    // 展开所有
    expandAll() {
      this.setTreeExpanded(true)
    },

    // 折叠所有
    collapseAll() {
      this.setTreeExpanded(false)
    },

    setTreeExpanded(expanded) {
      const nodes = this.$refs.permissionTree.store._getAllNodes()
      nodes.forEach(node => {
        node.expanded = expanded
      })
    },

    // 保存权限
    async handlePermissionSubmit() {
      this.permissionSubmitLoading = true
      try {
        const menuKeys = this.$refs.permissionTree.getCheckedKeys(true)

        const response = await saveRoleMenus({
          menu_keys: menuKeys,
          role_id: this.currentRole.role
        })
        
        if (response.err_code === 0) {
          this.$message.success('保存成功，相关账号重新登录后生效')
          this.permissionDialogVisible = false
        } else {
          this.$message.error(response.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存权限失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.permissionSubmitLoading = false
      }
    },

    // 提交表单
    handleSubmit() {
      this.$refs.roleForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const url = this.isEdit ? '/v1/admin/cmn/role/edit' : '/v1/admin/cmn/role/add'
            const response = await request.request({
              url,
              method: 'post',
              data: this.formData
            })
            
            if (response.err_code === 0) {
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.loadTableData()
            } else {
              this.$message.error(response.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('保存角色失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },

    // 关闭对话框
    handleDialogClose() {
      this.$refs.roleForm && this.$refs.roleForm.resetFields()
      this.formData = {
        name: '',
        role: null,
        description: ''
      }
      this.isEdit = false
      this.isView = false
    },

    // 关闭权限对话框
    handlePermissionDialogClose() {
      this.permissionTreeData = []
      this.selectedPermissions = []
      this.currentRole = null
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadTableData()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadTableData()
    }
  }
}
</script>

<style scoped>
.role-manage {
  padding: 20px;
}

.search-card,
.operation-card,
.table-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

.menu-permission-tree {
  min-height: 420px;
  max-height: 560px;
  overflow: auto;
  border: 1px solid #ebeef5;
  padding: 12px;
}
</style>
